// NaverSearch.js
// import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Box } from '@mui/system';
import { IconButton, FormControl, InputLabel, OutlinedInput, InputAdornment, Button } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import FlexyTable from '../common/flexytable/FlexyTable';
import {naverSearchResultRepo, naverSearchRepo, poiEditCommandRepo} from '../../model/CvoModel';
import { AppNumber, AppPalette, AppWord, MapEvent, TableColumnType } from '../../model/AppConst';
import ValueUtil from '../../model/ValueUtil';
import { useReactiveVar } from '@apollo/client';
import { useContext, useRef } from 'react';
import { PromptContext } from '../hook/appPrompters';
import { useSnackbar } from 'notistack';

const TheContainer = styled(Box)({
	flexGrow:1, display:'flex', flexDirection:'column', //backgroundColor:'yellow'
});
const TableBox = styled(Box)({flexGrow:1, display:'flex',});

const HeaderBox = styled(Box)({
    display:'flex', alignItems:'center', height: AppNumber.HeaderToolBoxHeight, padding: AppNumber.SmallBoxPadding,
});

const ButtonBox = styled(Box)({flexGrow:1, textAlign:'right'});

const TableColumns = [
    { id: 'roadAddress', label: '도로주소', width: 140, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'jibunAddress', label: '지번주소', width: 140, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'englishAddress', label: '영문주소', width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
];

// const NaverCmd = {SetStart:'setStart', SetEnd:'setEnd'};

export default function NaverSearch({
    mapShell,
}) {
    // const [records, setRecords] = useState([]);
    const records = useReactiveVar(naverSearchResultRepo);
    //const [search, setSearch] = useState('');
    const search = useReactiveVar(naverSearchRepo);
    const { openConfirmDialog } = useContext(PromptContext);
    const { enqueueSnackbar } = useSnackbar();
    const markingAddrRef = useRef(null);


    const onChangeSearch = (event) => {
        naverSearchRepo(event.target.value);
    };

    const onClickSearchNaver = () => {
        if(ValueUtil.realLen(search) > 1) {
            mapShell.queryNaverGeocode(search, (status, response)=>{
                if(mapShell.isNaverResponseOk(status)) {
                    let num = 0;
                    naverSearchResultRepo(response.v2.addresses.map((addr)=>{
                        addr.index = ++num;
                        addr.lat = parseFloat(addr.y);
                        addr.lon = parseFloat(addr.x);
                        return addr;
                    }));
                }
                else console.log("오류 " + status);
            });
        }
        else console.log("Not less than 2 letters");
    };

    const onClickAddressMarker = async () => {
        console.log("onClickAddressMarker", markingAddrRef.current);
        if(markingAddrRef.current) {
            const addr = (markingAddrRef.current.info.roadAddress || markingAddrRef.current.info.jibunAddress);
            const msgs = ['지정한 주소에 지점을 추가하시겠습니까?'];
            if(addr) msgs.push(addr);
            const ok = await openConfirmDialog({
                title: "지점 추가",
                message: msgs,
                option: { yesLabel: '추가', noLabel: '취소' }
            });

            if(ok) {
                mapShell.clearAddrMarker();
                poiEditCommandRepo({
                    open: true,
                    lat: markingAddrRef.current.lat,
                    lon: markingAddrRef.current.lon,
                    addr: addr || search || '주소 없음',
                });
                markingAddrRef.current = null;
            }
        }
    };

    const onClickAddress = (row) => {
        // const addr = (row.roadAddress || row.jibunAddress).replace(/^\S+(시|도)\s+/, '');
        // mapShell.setCenter(row.lat, row.lon);
        markingAddrRef.current = {lat: row.lat, lon: row.lon, info: row};
        mapShell.showAddrMarker(row.lat, row.lon, [{eventKey: MapEvent.CLICK, callback: onClickAddressMarker}]);
        enqueueSnackbar('마커를 클릭하여 지점을 추가할 수 있습니다', {variant: 'info', autoHideDuration: 1500});
    };

    const InputID = "naver-search-poi-list";
    return (
        <TheContainer>
            <HeaderBox>
                <FormControl variant='outlined' size={AppWord.SMALL}>
                    <InputLabel htmlFor={InputID} style={{backgroundColor:'white'}}>NAVER 주소검색</InputLabel>
                    <OutlinedInput id={InputID} onChange={onChangeSearch}
                        value={search}
                        size={AppWord.SMALL}
                        onKeyUp={(e) => {if(e.key==='Enter') onClickSearchNaver()}}
                        endAdornment={
                            Boolean(search) ?
                            <InputAdornment position={AppWord.END}>
                                <IconButton
                                onClick={()=>{naverSearchRepo('')}}
                                size={AppWord.SMALL}
                                edge={AppWord.END}
                                >
                                    <ClearIcon />
                                </IconButton>
                            </InputAdornment>
                            :
                            null
                        }
                    />
                </FormControl>
                <ButtonBox>
                    <Button variant={AppPalette.VariantContained} onClick={onClickSearchNaver}>
                        <SearchIcon fontSize={AppWord.SMALL} />
                        &nbsp; 검색
                        </Button>

                </ButtonBox>
            </HeaderBox>
            <TableBox>
                <FlexyTable
                    name="naver_search"
                    uniqueKey="index"
                    columns={TableColumns}
                    records={Boolean(records) ? records : []}
                    tools={[]}
                    onClickOneRow={onClickAddress}
                />
            </TableBox>
        </TheContainer>
    )
}
